import { useAppQuery } from "./useAppQuery.js";
import { IShopState } from "../store/features/shop.js";

interface UseShopQueryOptions {
  onSuccess?: (shopData: IShopState) => void;
  enabled?: boolean;
}

export const useShopQuery = (options: UseShopQueryOptions) => {
  const {
    data,
    status,
    isLoading,
    isRefetching,
    isFetching,
    refetch,
  } = useAppQuery<IShopState, Error>({
    url: "/api/shop",
    reactQueryOptions: { ...options },
  });

  return {
    isLoading,
    isFetching,
    isRefetching,
    data,
    status,
    refetch,
  };
};